import axios from 'axios';

import { AUTH_TOKEN_TYPE } from '@/shared/constants';
import Vue from 'vue';

const TIMEOUT = 1000000;

const onRequestSuccess = config => {
  config.timeout = TIMEOUT;
  config.withCredentials = true;
  config.headers.get['Cache-Control'] = 'no-cache';
  config.headers.get['Pragma'] = 'no-cache';
  if (config.url.startsWith('api/')) {
    config.url = `${(<any>window).TAU_SERVER_API_URL || '/'}${config.url}`;
    console.debug(config.url);
  }
  return config;
};

const setupAxiosInterceptors = onUnauthenticated => {
  const onResponseError = err => {
    const status = err.status || err.response.status;
    if (status === 403 || status === 401) {
      onUnauthenticated();
    }
    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(res => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
